module.exports = __webpack_public_path__ + "static/media/Fanzone_tagline.8928a6ec.png";